import { render, staticRenderFns } from "./marketingTopTittle.vue?vue&type=template&id=2460d046"
import script from "./marketingTopTittle.vue?vue&type=script&lang=js"
export * from "./marketingTopTittle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports